// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Table_wrap__1zSfk","expander":"Table_expander__3_IdR"};